import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import logo from "./logo-looktacom.png";

const Login = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        console.log("%c--- DÉBUT LOGIN ---", "color: blue; font-weight: bold");
        setLoading(true); // On active le chargement visuel
        setError("");

        try {
            const response = await fetch("https://suivis.looktacom.fr/api/login.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ username, password }),
                credentials: "include",
            });

            console.log("%cStatut HTTP :", "color: orange", response.status);

            // On récupère le texte brut d'abord pour debug si besoin
            const rawText = await response.text();
            console.log("%cRéponse brute du serveur :", "color: green", rawText);

            // Maintenant on essaie de parser le JSON
            try {
                const data = JSON.parse(rawText);

                if (data.success) {
                    console.log("Succès ! Redirection...");

                    // 1. Stocker le Nom de l'utilisateur
                    localStorage.setItem("userName", data.user.nom);

                    // 2. Gestion du rôle Admin (Dynamique selon la BDD)
                    // Si ton user a le rôle 'admin', on le stocke
                    const isAdmin = data.user.role === 'admin' ? "true" : "false";
                    localStorage.setItem("isAdmin", isAdmin);

                    // 3. --- NOUVEAU : GESTION PERMISSION FACTURATION ---
                    // On récupère la valeur (0 ou 1) et on la stocke en "true"/"false"
                    // Assure-toi que ton API login.php renvoie bien 'acces_facturation' dans l'objet 'user'
                    const accessFactu = data.user.acces_facturation == 1 ? "true" : "false";
                    localStorage.setItem("canBilling", accessFactu);

                    // Redirection
                    navigate("/suivi-production");
                } else {
                    setError(data.message || "Identifiants incorrects");
                }
            } catch (jsonErr) {
                console.error("Erreur de parsing JSON", jsonErr);
                setError("Erreur format serveur (JSON invalide)");
            }

        } catch (err) {
            console.error("%cERREUR RÉSEAU / CORS :", "color: red", err);
            setError("Le serveur ne répond pas (Problème réseau ou CORS)");
        } finally {
            setLoading(false); // On arrête le chargement quoi qu'il arrive
        }
    };

    return (
        <div className="login-page">
            <div className="login-card">
                <img src={logo} alt="Lookta'com" className="login-logo" />
                <form onSubmit={handleLogin}>
                    <h2>Accès Suivi Production</h2>

                    {error && <div className="error-badge">{error}</div>}

                    <div className="input-group">
                        <input
                            type="text"
                            placeholder="Utilisateur"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                    </div>

                    <div className="input-group">
                        <input
                            type="password"
                            placeholder="Mot de passe"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>

                    <button type="submit" className="btn-login" disabled={loading}>
                        {loading ? "Connexion..." : "Se connecter"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Login;